import RsvpCard from './RsvpCard';
import RsvpMinimal from './RsvpMinimal';
import RsvpSoftCard from './RsvpSoftCard';
import RsvpLuxeCard from './RsvpLuxeCard';
import RsvpDetailed from './RsvpDetailed';
import RsvpImmersive from './RsvpImmersive';

const VARIANTS = {
  'rsvp-card': RsvpCard,
  'rsvp-minimal': RsvpMinimal,
  'rsvp-soft-card': RsvpSoftCard,
  'rsvp-luxe-card': RsvpLuxeCard,
  'rsvp-detailed': RsvpDetailed,
  'rsvp-immersive': RsvpImmersive,
};

export default function RsvpSection({ section, data, theme, settings, rsvpRef }) {
  const Variant = VARIANTS[section.variant] || RsvpCard;
  return <Variant section={section} data={data} theme={theme} settings={settings} rsvpRef={rsvpRef} />;
}
